import { isString } from 'lodash';

export default function PipelineNameCell({ requestPayload }) {
  return getPipelineName(requestPayload);
}

function getPipelineName(requestPayload) {
  try {
    const parsed = isString(requestPayload) ? JSON.parse(requestPayload) : requestPayload;
    return parsed?.data?.pipeline_name ?? '—';
  } catch {
    return '—';
  }
}
